(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scs-cookie-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.scsCookieControls) {
      window.scsCookieControls.refresh();
      return;
    }

    let apiReady = false;
    let loadAttempted = false;
    let resizeScheduled = false;
    const openingLinks = new WeakSet();

    const videoAllowed = () => {
      if (!apiReady) return false;
      try {
        const privacy = window.Shopify.customerPrivacy;
        const consent = privacy.currentVisitorConsent();
        return consent.analytics === 'yes' && consent.marketing === 'yes'
          && privacy.analyticsProcessingAllowed() === true
          && privacy.marketingAllowed() === true;
      } catch {
        return false;
      }
    };

    const syncVideos = () => {
      const allowed = videoAllowed();
      document.querySelectorAll('[data-scs-consent-video]').forEach((wrapper) => {
        const active = wrapper.querySelector('[data-scs-active-video]');
        const placeholder = wrapper.querySelector('[data-scs-video-placeholder]');
        const visible = wrapper.getClientRects().length > 0;
        if (!allowed || !visible) {
          if (active) active.remove();
          if (placeholder) placeholder.hidden = false;
          return;
        }
        if (active) return;
        const template = wrapper.querySelector('template[data-scs-video-template]');
        const source = template?.content.querySelector('iframe');
        if (!source) return;
        const frame = source.cloneNode(true);
        frame.setAttribute('data-scs-active-video', '');
        wrapper.appendChild(frame);
        if (placeholder) placeholder.hidden = true;
      });
    };

    const initialize = () => {
      if (loadAttempted) {
        syncVideos();
        return;
      }
      if (window.Shopify?.customerPrivacy) {
        loadAttempted = true;
        apiReady = true;
        syncVideos();
        return;
      }
      if (typeof window.Shopify?.loadFeatures !== 'function') {
        syncVideos();
        return;
      }
      loadAttempted = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          apiReady = !error && Boolean(window.Shopify?.customerPrivacy);
          syncVideos();
        });
      } catch {
        apiReady = false;
        syncVideos();
      }
    };

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target?.closest?.('a[data-scs-cookie-settings]');
      if (!link || (link.target && link.target !== '_self')) return;
      if (typeof window.privacyBanner?.showPreferences !== 'function') return;
      event.preventDefault();
      if (openingLinks.has(link)) return;
      openingLinks.add(link);
      const fallback = () => window.location.assign(link.href || '/pages/privacy-policy');
      try {
        Promise.resolve(window.privacyBanner.showPreferences())
          .catch(fallback)
          .finally(() => openingLinks.delete(link));
      } catch {
        openingLinks.delete(link);
        fallback();
      }
    });

    document.addEventListener('visitorConsentCollected', syncVideos);
    document.addEventListener('shopify:section:load', initialize);
    window.addEventListener('load', initialize, { once: true });
    window.addEventListener('resize', () => {
      if (resizeScheduled) return;
      resizeScheduled = true;
      window.requestAnimationFrame(() => {
        resizeScheduled = false;
        syncVideos();
      });
    }, { passive: true });
    window.scsCookieControls = { refresh: initialize };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
